import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';

import './AccessList.scss';

const dataList = [
  {
    icon: '🍓',
    title: 'Flirt with AI-characters',
  },
  {
    icon: '🦄',
    title: 'Exclusive characters',
  },
  {
    icon: '💌',
    title: 'Conversations with no limits',
  },
  {
    icon: '📸',
    title: 'Exclusive in-chat visuals',
  },
  {
    icon: '⌛',
    title: 'Priority responses',
  },
];

export const OnboardingPaywallSectionAccessList: React.FC = () => {
  return (
    <section className="access-list">
      <OnboardingTitle className="title">
        Spice up your life with
        <br />
        <UiTypography variant="inherit" color="gradient" component="span">
          full access to everything
        </UiTypography>
      </OnboardingTitle>
      <div className="access-list-items">
        {dataList.map((access) => (
          <UiTypography
            key={access.title}
            variant="body-medium"
            className="access-list-item"
          >
            <UiTypography variant="title-large" component="span">
              {access.icon}
            </UiTypography>
            {access.title}
          </UiTypography>
        ))}
      </div>
    </section>
  );
};
